import { useEffect, useState } from "react";
import { usePosition } from "use-position";

const Position = ({ map, center }) => {
  const [centerHeight, centerWidth] = center;
  const [startingPosition, setStartingPosition] = useState({
    latitude: null,
    longitude: null,
  });
  const { latitude, longitude, error } = usePosition(true, {
    enableHighAccuracy: true,
  });
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (error) {
      setShowError(true);
      map.dragging.enable();
    }
  }, [error]); // eslint-disable-line

  useEffect(() => {
    if (!startingPosition.latitude && !startingPosition.longitude) {
      setStartingPosition({
        latitude,
        longitude,
      });
    } else {
      const params = new URLSearchParams(window.location.search);
      const scale = params.get("scale") ?? 1000000;
      const offsetX = (startingPosition.latitude - latitude) * scale;
      const offsetY = (startingPosition.longitude - longitude) * scale;
      const y = centerHeight + offsetX;
      const x = centerWidth + offsetY;
      map.panTo([y, x]);
    }
  }, [latitude, longitude]); // eslint-disable-line

  return (
    <>
      {showError && (
        <div className="error-gps">
          <p className="error-gps__text">
            Dear wanderer... I'm unable to get your gps location. Check your
            settings or try a different browser (older versions of Safari don't
            work reliable).
          </p>
          <p className="error-gps__text">
            Otherwise you're now free to navigate the map by dragging.
          </p>
          <button
            type="button"
            className="error-gps__btn"
            onClick={() => setShowError(false)}
          >
            Dismiss
          </button>
        </div>
      )}
    </>
  );
};

export default Position;
